import React from "react";
import "./MyStoreDisplay.css";
import config from "../../../config";
import fetchWithAuth from "../../../services/fetchWithAuth";
import { useNavigate } from "react-router-dom/dist";
import { encodeQueryParameter, parseParticipantID } from "../../../CommonFunctions";
import { ParticipantDashboardShareButton } from "../../../components/Storefront/ShareStoreComponent";
import { FundraiserInfo } from "../../../Interfaces/FundraiserRole";

interface MyStoreDisplayProps {
  fundraiserInfo: FundraiserInfo;
}

const MyStoreDisplay: React.FC<MyStoreDisplayProps> = ({ fundraiserInfo }) => {
  const storeLink = `${config.REACT_APP_SITE_URL}participant-shop/part-id/${fundraiserInfo.participant_code.toLowerCase()}`;
  const navigate = useNavigate();

  const handleEmail = () => {
    createShareLog();
    const participantsQuery = encodeQueryParameter({
      participants: `${fundraiserInfo.participant_code}`,
    });

    navigate(`/fundraiser/participant/add-contacts/${participantsQuery}`);
  };

  const handleText = () => {
    createShareLog();
    alert("Text clicked");
  };

  const createShareLog = async () => {
    try {
      const response = await fetchWithAuth(`${config.API_BASE_URL}share-log/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          participant_id: parseParticipantID(fundraiserInfo.participant_code),
        }),
      });
    } catch (error) {
      console.error("Error creating share log:", error);
    }
  };

  return (
    <div className="participant-dashboard-store-card">
      <h3 className="participant-dashboard-store-title">My Store</h3>

      <div className="participant-dashboard-store-link-box">
        <div className="participant-dashboard-store-icon">🔗</div>

        <div className="participant-dashboard-store-content">
          <span className="participant-dashboard-store-label">STORE LINK</span>

          <span className="participant-dashboard-store-link">{storeLink}</span>
        </div>
      </div>

      <div className="participant-dashboard-store-code-box">
        <div className="participant-dashboard-store-content">
          <span className="participant-dashboard-store-label">
            PARTICIPANT CODE
          </span>

          <span className="participant-dashboard-store-code">
            {fundraiserInfo.participant_code.toUpperCase()}
          </span>

          <span className="participant-dashboard-store-description">
            Customers can search this to find your store
          </span>
        </div>
      </div>

      <div className="participant-dashboard-store-actions">
        <ParticipantDashboardShareButton
          fundraiserName={fundraiserInfo.fundraiser_name}
          participantName={fundraiserInfo.participant_name}
          fundraiserCode={fundraiserInfo.participant_code}
          buttonText="Share Store"
          extraFunctionality={createShareLog}
        />

        <button
          className="participant-dashboard-store-button"
          onClick={handleEmail}
        >
          ✉ Email
        </button>
        {/*
          TODO: Actual texting service is yet to be implemented, so leaving this out for now to avoid confusion
        <button
          className="participant-dashboard-store-button"
          onClick={handleText}
        >
          💬 Text
        </button>
        */}
      </div>
    </div>
  );
};

export default MyStoreDisplay;
